import {Component, EventEmitter, Input, OnInit, Output, Inject, NgZone, OnDestroy} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AddOpportunityService} from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import {SharedModalService} from "@app/shared-modal/service/shared-modal.service";
import {AuthService} from "@app/core";

declare var $: any;
declare var tinymce: any;

@Component({
  selector: 'app-cs-call-log-modal',
  templateUrl: './call-log-modal.component.html',
  styleUrls: ['./call-log-modal.component.scss']
})
export class CallLogModalComponent implements OnInit, OnDestroy {
  callForm: FormGroup;
  customerCallDetails: object;
  callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
  scheduled: boolean = true;
  editId:any;
  subscriptions:any = {};
  callActivityShow: boolean = false;
  activityIsScheduled: Array<any> = [];
  completed: boolean = true;
  scheduledData: any;
  saveDisabled:boolean = false;
  isContactNotFound : boolean = false ;
  todayActivityId:any;
  showAddNewTemplate = false;
  showTemplateList: boolean = false;
  tinyMCEIntervel: any;
  editor: any;
  customTagsList: any[] = [];
  customTagForm: FormGroup;
  customFieldForm: FormGroup;
  customFields = [];
  customFieldsDirectResponse = null;
  showRecommendation = false;
  selectedCallNoteTemplate: any;
  isCallCustomFieldEnabled = false;
  getCustomFieldCall:any;
  // customFieldInputs: any = {};
  @Input() customerId: number;
  @Input() opportunityId: number;
  @Input() showCallLogModal: boolean = false;
  @Input() editCallData:any;
  @Input() activityList:any;
  @Input() completedActivityData: any;
  @Input() showCallCustomFields = false;
  @Input() showCallNoteTemplateOption = false;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Input() usersList: any;
  users: any = [];
  selectedUsersList: any = [];
  @Input() screen = '';
  constructor(private fb : FormBuilder,
              private opportunityService: AddOpportunityService,
              private sharedModalService: SharedModalService,
              private zone: NgZone,
              private authService: AuthService,
              @Inject('confirmationBoxHelper') private confirmationBoxHelper,
              @Inject('$scope') private ajsScope){
      this.isCallCustomFieldEnabled = this.authService.permitted(['UseCallFields.readaccess']) === true;
  }

    ngOnInit() {
        this.customTagForm = this.fb.group({});
        if(this.showCallCustomFields) {
            this.opportunityService.listCallCustomFields().subscribe((res: any) => {
                this.getCustomFieldCall = res;
                this.buildCustomeFieldForm(res);
                this.customFieldsDirectResponse = res['customCallField'];
                // To show the list in this specific order, we mapped like this
                if(res['customCallField']['Reason for call']) {
                    this.customFields.push({key: 'Reason for call', value: res['customCallField']['Reason for call']})
                }
                if(res['customCallField']['Type of call']) {
                    this.customFields.push({key:'Type of call', value: res['customCallField']['Type of call']})
                }
                if(res['customCallField']['Outcome of call']) {
                    this.customFields.push({key:'Outcome of call', value: res['customCallField']['Outcome of call']})
                }
            });
        }
        this.getUserList();
    }

    buildCustomeFieldForm(field:any){
        let csof: any = {};
        Object.entries(field['customCallField']).forEach((item) => {
            csof[item[0]] = new FormControl('', Validators.required);
        });
        this.customFieldForm = this.fb.group(csof);
    }

    ngOnChanges(changes){
        if(changes.showCallLogModal){
            if (this.editCallData &&
                this.editCallData.communications &&
                this.editCallData.communications.opportunity) {
                this.screen = 'opportunity_notes';
                this.getUserList();
            }
            if (this.getCustomFieldCall) {
                this.buildCustomeFieldForm(this.getCustomFieldCall);
            }
            if(this.showCallLogModal){
                this.getUserList();
                if (this.editCallData == null) {
                    let showContent = 'call';
                    if (this.activityList) {
                       /* for (var filter = 0; filter < this.activityList.length; filter++) {
                            // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                    && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                    this.activityIsScheduled.push(this.activityList[filter])
                            // }
                        }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true;
                            for (let i = 0; i <= this.activityList[1].length; i++) {
                                if(this.activityList[1][i] && this.activityList[1][i].template) {
                                    this.selectedCallNoteTemplate = this.activityList[1][i].template;
                                    this.showRecommendation = true;
                                    break;
                                }
                            }
                            this.completed = true
                        } else {
                            this.callActivityShow = false
                            this.completed = false
                        }
                    }
                    if(this.completedActivityData && (this.completedActivityData.template || this.completedActivityData.templateName)) {
                        this.selectedCallNoteTemplate = this.completedActivityData;
                        this.showRecommendation = true;
                    }
                    this.buildForm();
                    setTimeout(() => {
                        this.todayActivity()
                    }, 500);
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    // setTimeout(() => {
                    //     this.updateTinyMCEValues();
                    // }, 100);
                }
                else{
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId
                        this.callActivityShow = false;
                        this.buildForm()
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note": this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        });
                        setTimeout(() => {
                            const cfs = this.editCallData.communications['customFields'];
                            let editedCfs: any = {};
                            Object.entries(cfs).forEach((kvArray) => {
                                if (kvArray[1]){
                                    editedCfs[kvArray[0]] = this.customFieldsDirectResponse[kvArray[0]].find((f: any) => f.id == kvArray[1]);
                                }
                            });
                            this.customFieldForm.patchValue(editedCfs);
                            // increased 500 ms extra to get customFieldsDirectResponse
                        }, 1500);
                        $(".modal-header").css("background", "#5E6D7F")
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open")
                        $('.callLogModal').addClass('in');
                        // setTimeout(() => {
                        //     this.updateTinyMCEValues();
                        // }, 100);
                    }
                }
            }
        }
        if (this.completedActivityData && (this.completedActivityData['template'] == null || (this.completedActivityData['template']['name'] == null && this.completedActivityData['template']['customTags'] == null && this.completedActivityData['template']['message'] == null))){
            // this.showCallNoteTemplateOption = false;
            this.showRecommendation = false;
            this.getUserList();
        }
        if(changes.customerId && this.customerId){
          this.getCustomerCall();
        }
    }

    getCustomerCall() {
        this.opportunityService.getCustomerContact(this.customerId).subscribe(
            data => {
				if (Object.values(data).length) {
                    this.customerCallDetails = data;
				}else{
					this.isContactNotFound =true;
				}
			}
        )
    }

    todayActivity() {
        this.opportunityService.getScheduledEmail(this.opportunityId,'Call').subscribe((resp: any) => {
            if (resp) {
                if (resp.length && resp[0].length) {
                    this.callActivityShow = true;
                    this.completed = true;
                    this.todayActivityId = resp[0];
                }
                else {
                    this.callActivityShow = false;
                    this.completed = false;
                }
            }
        })
    }

    isFieldsValid(cf: any[]) {
        const isValidElement = cf.find((cfElement) => cfElement.archived === 0);
        return this.editId ? true : !!isValidElement;
    }

    buildForm(){
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    }

    closeModal(emitEvent = true){
        this.editId = null
		this.callForm.controls['activityType'].setValue('')
		this.callForm.controls['customerId'].setValue('')
		this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        if(this.screen == 'opportunity_call_log' || this.screen == 'opportunity'){
            this.scheduled = true;
        } else {
            this.scheduled = false;
        }
        this.activityIsScheduled = [];
        this.callActivityShow = false;
        this.showTemplateList = false;
        this.customTagForm = new FormGroup({});
        this.customFieldForm.reset();
        this.customTagsList = [];
        this.showRecommendation = false;
        this.completedActivityData = null;
        this.selectedCallNoteTemplate = null;
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if(emitEvent)
            this.onClose.emit(false);
    }

    isScheduledActivity(event) {
        this.scheduled = event.target.checked
    }

    completeActivity(event) {
		this.completed = event.target.checked
	}

    saveCall() {
        this.saveDisabled = true
        this.callForm.get('customerId').setValue(this.customerId);
        let callData = this.callForm.value;
        if (this.completed) {
			callData = this.callForm.value
			let activityId = this.todayActivityId;
			/*if (this.activityIsScheduled.length != 0) {
				for (var i = 0; i < this.activityIsScheduled.length; i++) {
					activityId.push(this.activityIsScheduled[i]['activity_id'])
				}
			} else {
				if (this.scheduledData) {
					if (this.scheduledData.hasOwnProperty('activity_id')) {
						activityId.push(this.scheduledData.activity_id)
					} else {
						activityId.push(this.scheduledData.activityId)
					}
				}
			}*/
			callData.activityIds = activityId
            if (this.todayActivityId) {
                callData.activityIds = this.todayActivityId;
            }
		}
        if(this.customTagsList && this.customTagsList.length) {
            callData.customTags = this.customTagForm.value;
        }
        if(this.customFieldForm.valid && this.customFieldForm.value) {
            callData.callCustomField = this.customFieldForm.value;
        }
        // this.editId = event.editId;
        // callData.activityIds = this.activityEmail;
        let url;
        if (this.editId) {
            callData['opportunityId'] = this.opportunityId;
            this.screen == 'opportunity_notes' ? callData['communicationId'] = this.editCallData.communications.tablePkId : callData['communicationId'] = this.editCallData.communications.communicationId;
            url = `sales/edit_opportunity_call/${this.editId}`
        } else {
            url = `sales/opportunityActivityCall/${this.opportunityId}`
        }
        callData['selectedUsersList'] = this.selectedUsersList.length > 0 ? this.selectedUsersList : [];
        this.opportunityService.createOpportunityCall(callData, url).subscribe(
            data => {
                this.sharedModalService.updateModalStatus('opportunity', 'call', false);
                // If this schedule, open the schedule activity modal
                this.onSave.emit(this.scheduled);
                this.closeModal();
                this.saveDisabled = false;
                // if (this.scheduledData) {
                //     if (this.scheduledData.hasOwnProperty('activityId')) {
                        this.opportunityService.refreshCompleteActivity('complete');
                //     }
                // }
            });
    }

    closeModalConfirmation() {
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
            .then(() => {
                this.closeModal();
            }).catch(() => { });
    }

    setTemplateDetails(selectedTemplate) {
        selectedTemplate.message = selectedTemplate.message ? selectedTemplate.message : selectedTemplate.value;
        selectedTemplate.message = selectedTemplate.template ? selectedTemplate.template.message : selectedTemplate.message;
        this.callForm.controls['note'].setValue(selectedTemplate['message']);
        if(selectedTemplate.customTags || (selectedTemplate.template && selectedTemplate.template.customTags)) {
            this.customTagForm = new FormGroup({});
            let customTagsList = JSON.parse(selectedTemplate.customTags || selectedTemplate.template.customTags);
            customTagsList = customTagsList.map((ct) => {
                ct.name = ct.name.replaceAll('{', '').replaceAll('}', '');
                this.customTagForm.addControl(ct.name, new FormControl('', Validators.required));
                return ct;
            });
            this.customTagsList = customTagsList;
        } else {
            this.customTagsList = [];
            this.customTagForm = new FormGroup({});
        }
        // this.updateTinyMCEValues();
        $(".template-wrapper").removeClass("template-open")
        this.showTemplateList = false;
    }

    showTemplateOptions() {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    }

    cancelTemplate() {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    }

    onChange = () => {
      const message = this.callForm.value.note;
      if(this.showCallNoteTemplateOption) {
          this.customTagsList.forEach((ct) => {
              if (!message.includes(`>{${ct.name}}</`) && !this.customTagForm.controls[ct.name].value) {
                  this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                  this.customTagForm.controls[ct.name].disable();
              }
          })
      }
    };

    replaceCustomTags(tagName: any) {
        const replacingValue = this.customTagForm.value[tagName.replaceAll('{', '').replaceAll('}', '')];
        if(replacingValue) {
            const iframe = $('quill-editor');
            const cts = $("span[data-value='"+tagName+"']", iframe.contents())
            cts.each((index, ct) => {
                $(ct).find('span').html(replacingValue);
                $(ct).removeClass('mention custom_tag');
            });
            const updatedNote = iframe.contents().find('.ql-editor')[0].innerHTML;
            this.callForm.controls.note.setValue(updatedNote);
        }
    }
    ngOnDestroy(){
        this.opportunityService.refreshCompleteActivity(null);
        this.customFields = [];
    }

    onContentChange(event) {
        if (event.text === '\n') {
            this.saveDisabled = true;
        } else {
            this.saveDisabled = false;
        }
        this.onChange();
        const contentEl = $(event.html).find('[data-denotation-char=""]');
        this.selectedUsersList = [];
        if(contentEl.length) {
            for (let i = 0; i < contentEl.length; i++) {
                let index = this.selectedUsersList.findIndex((data: any) => data == contentEl[i].dataset['id']);
                if(index < 0) {
                    this.selectedUsersList.push(contentEl[i].dataset['id']);
                }
            }
        }
    }

    getUserList() {
        if (this.usersList) {
            for (let index = 0; index < this.usersList.length; index++) {
                this.usersList[index]['value'] = this.usersList[index]['username'];
                this.users.push(this.usersList[index]);
            }
        }

    }
}
